export default "__VITE_ASSET__C5Bcp9uw__"